import * as Sentry from "@sentry/react"
import { createRouter } from "@tanstack/react-router"

import { NotFoundScreen } from "@/components/errors/not-found-screen"
import { RouterErrorComponent } from "@/components/errors/router-error-component"
import { queryClient } from "@/lib/query-client"
import { shouldReportRouteError } from "@/lib/route-error-utils"

import { routeTree } from "./routeTree.gen"

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    queryClient,
  },
  defaultErrorComponent: RouterErrorComponent,
  defaultNotFoundComponent: NotFoundScreen,
  // Fires once per caught error (render bodies double-invoke under StrictMode; this doesn't).
  // Reports ONLY errors that don't already flow through TanStack Query's cache-level onError
  // (ApiError / network failures) — render/programming errors are otherwise invisible to Sentry
  // because error boundaries swallow them from the global handler. `@sentry/react` is imported
  // directly: `@/lib/sentry` imports this module, so importing it back would cycle.
  defaultOnCatch: (error) => {
    if (shouldReportRouteError(error)) {
      Sentry.withScope((scope) => {
        scope.setTag("source", "router-error-boundary")
        Sentry.captureException(error)
      })
    }
  },
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
